import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import AdminLayout from './components/AdminLayout';
import AdminDashboard from './pages/AdminDashboard';
import UserManagement from './pages/UserManagement';
import RoleManagement from './pages/RoleManagement';
import CreateEditRole from './pages/CreateEditRole';
import PermissionSetup from './pages/PermissionSetup';
import PermissionManagement from './pages/PermissionManagement';
import PortalConfiguration from './pages/PortalConfiguration';

const AdminConsole = () => {
  return (
    <Box>
      <AdminLayout>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<AdminDashboard/>}/>
          <Route path="/users" element={<UserManagement />} />
          <Route path="/roles" element={<RoleManagement />} />
          <Route path="/roles/create" element={<CreateEditRole />} />
          <Route path="/roles/edit/:id" element={<CreateEditRole />} />
          <Route path="/permission-setup" element={<PermissionSetup />} />
          <Route path="/permission-management" element={<PermissionManagement />} />
          <Route path="/portals" element={<PortalConfiguration />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AdminLayout>
    </Box>
  );
};

export default AdminConsole;
